<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-12"></div>
    </div>

    <div class="install-control">
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  watch: {},
  components: {
    informator: () => import("./Informator"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    send() {
      this.$loading(true);

      let data = {
        loan_id: this.transaction["exchange_id"],
        offer_id: this.value["id"],
      };

      this.$http({
        url: `${this.partner["endpoint_url"]}accept-offer`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: data,
      })
        .then((response) => {
          if (response.data) {
            console.log("vale", this.value);
            //IS IFRAME
            if (this.value["offer_type"] == "TBCLimitPublic") {
              this.createTransaction({
                step: "tbc-accept",
                api_result: JSON.stringify(response.data),
              });
              this.$emit("setStep", "tbc-accept");
            }
            //VENDOO FLOW
            else if (response.data.result == true) {
              this.createTransaction({
                step: "need-cancel",
                api_result: JSON.stringify(response.data),
              });
              this.$emit("setStep", "confirm-sign-contract-otp");
              this.$emit("input", response.data);
            }
          }
        })
        .catch((error) => {
          this.createTransaction({
            step: "need-cancel",
            api_result: JSON.stringify(response.data),
          });
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      data: {},
    };
  },
};
</script>

